import { RVRoutingPage } from "@regal-voice/ui";

import { AgentSettingsSubnav } from "./Components/AgentSettingsSubnav/AgentSettingsSubnav";
export default function AgentSettingsRoutingPage(): JSX.Element {
    return <RVRoutingPage nav={<AgentSettingsSubnav />} />;
}
